<template>
  <div class="padres-container">

    <!-- VIDEO DE FONDO MANTENIDO INTACATO -->
    <video
      class="video-fondo"
      autoplay
      muted
      loop
      playsinline
    >
      <source src="@/assets/vv1.mp4" type="video/mp4" />
    </video>

    <!-- Overlay premium satinado claro para legibilidad -->
    <div class="overlay-rosado"></div>

    <!-- CONTADOR -->
    <div ref="contadorRef" class="contador-container">
      <div class="rasgado rasgado-superior"></div>

      <!-- PÉTALOS DECORATIVOS INCRUSTADOS DE LA IMAGEN -->
      <img src="@/assets/petalo.avif" class="petalo-counter petalo-izq" alt="" />
      <img src="@/assets/petalo.avif" class="petalo-counter petalo-der" alt="" />

      <!-- TÍTULO EDITORIAL PRINCIPAL (THE COUNTDOWN HAS BEGUN) -->
      <div class="frase-container">
        <h2 ref="fraseLinea1" class="titulo-countdown-top"></h2>
        <h2 ref="fraseLinea2" class="titulo-countdown-top">CUENTA</h2>
        <p ref="fraseLinea3" class="titulo-countdown-top">REGRESIVA</p>
      </div>

      <!-- FRASE CALIGRÁFICA INTERMEDIA (ONLY LEFT!) -->
      <div class="contador-titulo">
        <span ref="onlyLeftRef" class="only-left-script">Solo Faltan:</span>
      </div>

      <!-- BLOQUE DE NÚMEROS EDITORIALES CON DOS PUNTOS COINCIDENTES -->
      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">DÍAS</span>
        </div>
        
        <span class="separador-puntos">:</span>

        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">HORAS</span>
        </div>

        <span class="separador-puntos">:</span>

        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">MIN</span>
        </div>

        <span class="separador-puntos">:</span>

        <div ref="tiempoRef4" class="tiempo">
          <!-- El contenedor interno del segundo tiene un ref dinámico para la animación en vivo -->
          <span ref="segundoNodo" class="numero cambiar-segundo">{{ segundos }}</span>
          <span class="etiqueta">SEG</span>
        </div>
      </div>

      <div class="rasgado rasgado-inferior"></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const contadorRef = ref(null)
    const fraseLinea1 = ref(null)
    const fraseLinea2 = ref(null)
    const fraseLinea3 = ref(null)
    const onlyLeftRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)
    const segundoNodo = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-10-17T14:00:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    // 🌟 EFECTO MAGNÉTICO SUPER PADRE CADA VEZ QUE CAMBIAN LOS SEGUNDOS
    watch(segundos, () => {
      if (segundoNodo.value) {
        gsap.fromTo(segundoNodo.value,
          { scale: 1.15, opacity: 0.7, filter: 'blur(1px)' },
          { scale: 1, opacity: 1, filter: 'blur(0px)', duration: 0.35, ease: 'power2.out' }
        )
      }
    })

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // CONFIGURACIÓN ESTADO INICIAL
      gsap.set(contadorRef.value, { autoAlpha: 0, y: 40 })
      gsap.set([fraseLinea1.value, fraseLinea2.value, fraseLinea3.value], { autoAlpha: 0, y: -25 })
      gsap.set(onlyLeftRef.value, { autoAlpha: 0, scale: 0.9, y: 15 })
      gsap.set(
        [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value, '.separador-puntos'],
        { autoAlpha: 0, y: 20 }
      )
      gsap.set('.petalo-counter', { opacity: 0, scale: 0.7 })

      const el = contadorRef.value

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // Panel Base
          tl.to(el, {
            autoAlpha: 1,
            y: 0,
            duration: 1
          })

          // Título Escalonado (THE COUNTDOWN HAS BEGUN)
          tl.to([fraseLinea1.value, fraseLinea2.value, fraseLinea3.value], {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.15
          }, '-=0.5')

          // Script Intermedio (Only left!)
          tl.to(onlyLeftRef.value, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'back.out(1.4)'
          }, '-=0.3')

          // Aparición de los bloques numéricos con sus dos puntos
          tl.to(
            [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value, '.separador-puntos'],
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.08
            },
            '-=0.4'
          )

          // Pétalos laterales
          tl.to('.petalo-counter', {
            opacity: 0.85,
            scale: 1,
            duration: 0.8,
            stagger: 0.2
          }, '-=0.5')

          // Animación flotante continua en el contenedor
          gsap.to(el, {
            scale: 1.008,
            duration: 4,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })

          // Respiración orgánica continua en los pétalos
          gsap.to('.petalo-counter', {
            y: '+=10',
            rotation: '+=5',
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, { threshold: 0.25 })

      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      contadorRef,
      fraseLinea1,
      fraseLinea2,
      fraseLinea3,
      onlyLeftRef,
      tiempoRef1,
      tiempoRef2,
      tiempoRef3,
      tiempoRef4,
      segundoNodo,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Montserrat:wght@300;400;500&family=Great+Vibes&display=swap');

/* =========================
   CONTENEDOR GENERAL (MANTENIDO)
========================= */
.padres-container {
  position: relative;
  width: 100%;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

/* =========================
   VIDEO DE FONDO (MANTENIDO EXACTO)
========================= */
.video-fondo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* =========================
   OVERLAY PREMIUM SATINADO CLARO
========================= */
.overlay-rosado {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: radial-gradient(circle at 50% 50%, rgba(228, 181, 181, 0.678), rgba(253, 242, 243, 0.85));
}

/* =========================
   CONTENEDOR DEL CONTADOR EDITORIAL
========================= */
.contador-container {
  position: relative;
  z-index: 2;
  width: min(92vw, 440px);
  padding: 80px 20px 85px;
  text-align: center;
  box-sizing: border-box;
  opacity: 0;
  will-change: transform, opacity;
}

/* =========================
   TITULARES EDITORIALES (THE COUNTDOWN HAS BEGUN)
========================= */
.frase-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}

.titulo-countdown-top {
  font-family: 'bethany', serif;
  font-weight: 400;
  font-size: clamp(34px, 8.5vw, 42px);
  color: #ea99bf; /* Tono rosa pastel premium idéntico a image_fe8426.png */
  margin: 0;
  line-height: 1.1;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  will-change: transform, opacity;
}

/* =========================
   FRASE CALIGRÁFICA (ONLY LEFT!)
========================= */
.only-left-script {
  font-family: 'Viramontes', cursive;
  font-size: clamp(62px, 13vw, 64px);
  font-weight: 400;
  display: block;
  color: #2d2c2c; /* Color negro caligráfico exacto de la imagen */
  margin: 10px 0 28px 0;
  line-height: 1;
  will-change: transform, opacity;
}

/* =========================
   CONTADOR NUMÉRICO LUXURY
========================= */
.contador-numeros {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 12px;
  padding: 0 4px;
}

.tiempo {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 65px;
  will-change: transform, opacity;
}

.numero {
  font-size: clamp(36px, 9vw, 44px);
  font-weight: 400;
  font-family: 'Playfair Display', serif;
  color: #ea99bf; /* Tono rosa pastel premium idéntico a image_fe8426.png */
  line-height: 1;
}

.cambiar-segundo {
  display: inline-block;
  will-change: transform, opacity;
}

.etiqueta {
  font-size: clamp(11px, 2.8vw, 13px);
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  margin-top: 10px;
  color: #c184a0; /* Tono rosa pastel premium idéntico a image_fe8426.png */
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* Dos puntos separadores de la imagen */
.separador-puntos {
  font-family: 'Playfair Display', serif;
  font-size: clamp(30px, 7vw, 36px);
  color: #97667d; /* Tono rosa pastel premium idéntico a image_fe8426.png */
  line-height: 1;
  transform: translateY(-8px);
}

/* =========================
   PÉTALOS LATERALES COINCIDENTES
========================= */
.petalo-counter {
  position: absolute;
  width: min(18vw, 65px);
  height: auto;
  object-fit: contain;
  pointer-events: none;
  z-index: 3;
}

.petalo-izq {
  left: -8px;
  top: 50%;
  transform: translateY(-50%) rotate(-15deg);
}

.petalo-der {
  right: -10px;
  top: 35%;
  transform: scaleX(-1) rotate(20deg);
}

/* =========================
   RASGADOS MANTENIDOS EN SU LUGAR
========================= */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #ffffff;
  z-index: 3;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
  margin-top: -45px;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior {
  bottom: 0;
  margin-bottom: -45px;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

/* =========================
   RESPONSIVE OPTIMIZADO
========================= */
@media (max-width: 420px) {
  .contador-numeros { gap: 6px; }
  .tiempo { min-width: 55px; }
}
</style>